import { render, staticRenderFns } from "./qiniu.vue?vue&type=template&id=c539be50"
import script from "./qiniu.vue?vue&type=script&lang=js"
export * from "./qiniu.vue?vue&type=script&lang=js"
import style0 from "./qiniu.vue?vue&type=style&index=0&id=c539be50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports